export var ControllerMessageType;
(function (ControllerMessageType) {
    ControllerMessageType[ControllerMessageType["Run"] = 0] = "Run";
    ControllerMessageType[ControllerMessageType["Cancel"] = 1] = "Cancel";
    ControllerMessageType[ControllerMessageType["Terminate"] = 2] = "Terminate";
})(ControllerMessageType || (ControllerMessageType = {}));
export var WorkerMessageType;
(function (WorkerMessageType) {
    WorkerMessageType[WorkerMessageType["Init"] = 0] = "Init";
    WorkerMessageType[WorkerMessageType["UnchaughtError"] = 1] = "UnchaughtError";
    WorkerMessageType[WorkerMessageType["TaskError"] = 2] = "TaskError";
    WorkerMessageType[WorkerMessageType["TaskResult"] = 3] = "TaskResult";
})(WorkerMessageType || (WorkerMessageType = {}));
export function assertMessageEvent(event) {
    if (!(event instanceof MessageEvent))
        throw new Error("Not MessageEvent");
}
